import React from 'react';
import { Divider } from '@mui/material';

interface Props {
  borderStyle?: boolean;
}
export default function YatungDivider({ borderStyle }: Props) {
  return <Divider sx={{ borderStyle: borderStyle ? 'solid' : 'dashed', borderColor: '#6C708C', width: '100%' }} />;
}
